// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--lyCrL","aside":"a10a3f92e9--aside--qtjHI","close":"a10a3f92e9--close--YYjG7"};